module.exports = __webpack_public_path__ + "static/img/image@2x (14).66218815.png";